export const isLikelyUrlWithoutProtocol = possibleUrl => {
  const splitUrl = possibleUrl.split(/([/?].*)/);
  const domainString = splitUrl[0];
  const pathString = splitUrl[1] || '';
  const domainReg = /^([a-zA-Z0-9-]{1,61}\.){0,126}[a-zA-Z0-9-]{1,61}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?\/{0,1}$/;
  const pathReg = /^\/([^\s/]+?\/{0,1})*(\?[^\s/]*?)*?$|^$|^\?[^\s]*?$/;
  return domainReg.test(domainString) && pathReg.test(pathString);
};
export const isWhitespace = (input = '') => {
  return !input.trim();
};